var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.title}},[_c('vs-tabs',{attrs:{"value":_vm.activeTab}},[_c('vs-tab',{attrs:{"label":"Waiting For Execute"}},[_c('Waiting')],1),_c('vs-tab',{attrs:{"label":"Executed"}},[_c('Executed')],1),_c('vs-tab',{attrs:{"label":"Cancel Execute"}},[_c('Canceled')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }